export default {
  areas: {
    hero: {
      eyebrow: 'Zona de servicio',
      title: 'Cámaras de seguridad y alarmas en toda la región Rin-Meno',
      subtitle: 'De Fráncfort pasando por Offenbach, Hanau y Darmstadt hasta Groß-Gerau: SSG Signaltechnik planifica, instala y mantiene videovigilancia y alarmas para particulares y empresas, de forma personal y presencial.',
      ctaPrimary: 'Solicitar una primera consulta gratuita',
      ctaSecondary: 'Descubrir la videovigilancia',
    },
    breadcrumbHome: 'Inicio',
    breadcrumbCurrent: 'Zona de servicio',
    intro: {
      eyebrow: 'Dónde trabajamos para usted',
      title: 'Distancias cortas en toda la región',
      p1: 'Nuestro especialista en seguridad tiene su sede en Hainburg y se desplaza rápidamente por toda la región Rin-Meno. Cámara, videovigilancia o alarma: vamos a usted, analizamos su inmueble in situ e instalamos todo de forma limpia y profesional.',
      p2: 'Vivienda, edificio, local, oficina, almacén o taller: gestionamos proyectos de todos los tamaños en Fráncfort, Offenbach, Hanau, Darmstadt, Groß-Gerau y municipios cercanos.',
    },
    city: 'Ciudad',
    district: 'Distrito',
    coverage: {
      eyebrow: 'Arraigo local',
      title: 'Su especialista de la región, para la región',
      p1: 'Como especialista local en la región Rin-Meno, conocemos las necesidades y condiciones del lugar. Para su cámara o alarma: distancias cortas, contactos personales y citas rápidas.',
      p2: 'También nos desplazamos más allá de la región Rin-Meno según acuerdo. Escríbanos y comprobaremos qué es posible para su proyecto.',
      ctaPrimary: 'Consultar ahora',
      ctaSecondary: 'Descubrir sistemas de alarma',
      caption: 'Montaje y configuración personal in situ, desde Hainburg por toda la región Rin-Meno.',
    },
    cta: {
      title: '¿Cámara de seguridad o alarma para su inmueble?',
      lead: 'Le asesoramos sin compromiso y le mostramos qué solución encaja con su inmueble y presupuesto, en toda la región Rin-Meno.',
      primary: 'Solicitar una primera consulta gratuita',
      secondary: 'Iniciar el planificador de cámaras',
    },
  },
};